import { render } from "./HomeWidget.vue?vue&type=template&id=75c91f57&scoped=true"
import script from "./HomeWidget.vue?vue&type=script&lang=js"
export * from "./HomeWidget.vue?vue&type=script&lang=js"

import "./HomeWidget.vue?vue&type=style&index=0&id=75c91f57&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c91f57"]])

export default __exports__